export default __webpack_public_path__ + "static/media/linkedin.a889e776.svg";